import LatexMattressPage from "../components/pages/latexpage";

export default LatexMattressPage;
